import { Component } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import styles from "./CategoryProducts.module.css";
import * as actions from "../../store/actions/index";
import Spinner from "../Spinner/Spinner";
import FlexContainer from "../UI/FlexContainer/FlexContainer";
import ProductCard from "../ProductCard/ProductCard";
import { string_to_slug as slug } from "../../store/utility";
class CategoryProducts extends Component {
  // categoryTypeList = ["Latest", "Best Sale", "Top Rated", "On Sale"]

  state = {
    loading: true,
    productData: [],
    loadmore: false,
  };

  componentDidMount = () => {
    // console.clear()

    let {
      categoryName,
      subcategoryName,
      productType,
      categoryId,
      subcategoryId,
    } = this.props.match.params;
    this.props.getCategoryTypeList();
    this.props
      .returnSpecificProducts(
        categoryId,
        subcategoryId,
        productType,
        this.props.shop ? this.props.shop : null
      )
      .then((data) => {
        this.setState({ loading: false });
        this.setState({ productData: data });
        // this.props.onFetchWishlist(this.props.userId)
        //---------store in redux only when url is correct
        // this.props.updateCategoryName(this.props.match.params.id);
        // this.props.updateCategoryType(this.props.location.pathname.replace("category", "").replace(this.props.match.params.id, "").replaceAll("/", ""))
      })
      .catch(() => {});
  };

  handleLoadMoreCategoryProducts = async () => {
    try {
      this.setState({ loadmore: true });
      let {
        categoryName,
        subcategoryName,
        productType,
        categoryId,
        subcategoryId,
      } = this.props.match.params;
      let { leadsexhausted, lastDoc, limit } = this.props;
      let shop = this.props.shop ? this.props.shop : null;
      let data = await this.props.onLoadMoreCategoryProducts(
        categoryId,
        subcategoryId,
        productType,
        shop,
        leadsexhausted,
        lastDoc,
        limit
      );
      this.setState({ loadmore: false });
      this.setState({ productData: [...this.state.productData, ...data] });
    } catch (error) {
      this.setState({ loadmore: false });
    }
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      let {
        categoryName,
        subcategoryName,
        productType,
        categoryId,
        subcategoryId,
      } = this.props.match.params;
      this.setState({ productData: [] });
      this.setState({ loading: true });
      this.props
        .returnSpecificProducts(
          categoryId,
          subcategoryId,
          productType,
          this.props.shop ? this.props.shop : null
        )
        .then((data) => {
          this.setState({ loading: false });
          this.setState({ productData: data });
        });
    }
  };

  getNavUrl = (item) => {
    let {
      categoryName,
      subcategoryName,
      categoryId,
      subcategoryId,
      productType,
    } = this.props.match.params;
    let url = null;
    if (this.props.shop) {
      url =
        "/shop/" +
        slug(subcategoryName) +
        "/" +
        item.id.replaceAll(" ", "").toLowerCase() +
        "/" +
        categoryId +
        "/" +
        subcategoryId;
    } else {
      url =
        "/category/" +
        slug(categoryName) +
        "/" +
        slug(subcategoryName) +
        "/" +
        item.id.replaceAll(" ", "").toLowerCase() +
        "/" +
        categoryId +
        "/" +
        subcategoryId;
    }
    return url;
  };

  spinner = (
    <div className={styles.Spinner}>
      <Spinner />
    </div>
  );

  render() {
    let {
      categoryName,
      subcategoryName,
      categoryId,
      subcategoryId,
      productType,
    } = this.props.match.params;

    return (
      <>
        <nav
          className={
            "navbar navbar-light bg-light text-center d-flex justify-content-around " +
            styles.Navbar
          }
        >
          {/* renders the nav */}
          {this.props.categoryTypeList &&
            this.props.categoryTypeList.map((item) => (
              <NavLink
                onClick={() =>
                  this.props.updateCategoryType(
                    item.id.replaceAll(" ", "").toLowerCase()
                  )
                }
                to={this.getNavUrl(item)}
                key={item.id}
                className={styles.Link}
                activeClassName={styles.Active}
              >
                {item.name}
              </NavLink>
            ))}
        </nav>

        {this.state.productData.length > 0 ? (
          <div className="container container-md" style={{ padding: "20px" }}>
            <FlexContainer>
              {this.state.productData.map((product) => (
                <>
                  <ProductCard product={product} />
                </>
              ))}
            </FlexContainer>
            {!this.props.leadsexhausted ? (
              <div style={{ width: "100%", textAlign: "center" }}>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => this.handleLoadMoreCategoryProducts()}
                  disabled={this.state.loadmore}
                >
                  {this.state.loadmore ? "Loading" : "Load More"}
                </button>
              </div>
            ) : null}
          </div>
        ) : null}
        {this.state.loading ? this.spinner : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categoryName: state.categoryProducts.categoryName,
    categoryType: state.categoryProducts.categoryType,
    categoryTypeList: state.categoryProducts.categoryTypeList,
    leadsexhausted: state.categoryProducts.leadsexhausted,
    limit: state.categoryProducts.limit,
    lastDoc: state.categoryProducts.lastDoc,
    userId: state.auth.userId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    returnSpecificProducts: (categoryId, subcategoryId, productTypeId, shop) =>
      dispatch(
        actions.returnSpecificProducts(
          categoryId,
          subcategoryId,
          productTypeId,
          shop
        )
      ),
    getCategoryTypeList: () => dispatch(actions.getCategoryTypeList()),
    updateCategoryName: (categoryName) =>
      dispatch(actions.updateCategoryName(categoryName)),
    updateCategoryType: (categoryType) =>
      dispatch(actions.updateCategoryType(categoryType)),
    onLoadMoreCategoryProducts: (
      categoryId,
      subcategoryId,
      productTypeId,
      shop,
      leadsexhausted,
      lastDoc,
      limit
    ) =>
      dispatch(
        actions.loadMoreCategoryProducts(
          categoryId,
          subcategoryId,
          productTypeId,
          shop,
          leadsexhausted,
          lastDoc,
          limit
        )
      ),
    onFetchWishlist: (userId) => dispatch(actions.onFecthWishlist(userId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CategoryProducts));
